import {Realizations} from './Realizations'

export const RealizationsPage = Realizations;